import { MembershipTableItem } from '../../models/entities/membership';
import { PaginationLinks, PaginationMeta } from '../../models/entities/pagination';

export class PeopleResponse
{
    data: MembershipTableItem[];
    links: PaginationLinks;
    meta: PaginationMeta;

    constructor(request: any) {
        this.data = (request.data && request.data.length) ? request.data.map(tx => {
            return new MembershipTableItem(tx);
        }) : [];
        this.links = new PaginationLinks(request.links);
        this.meta = new PaginationMeta(request.meta);
    }
}
